import { render, staticRenderFns } from "./custom-links-tab.vue?vue&type=template&id=38af920e&scoped=true"
import script from "./custom-links-tab.vue?vue&type=script&lang=js"
export * from "./custom-links-tab.vue?vue&type=script&lang=js"
import style0 from "./custom-links-tab.vue?vue&type=style&index=0&id=38af920e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af920e",
  null
  
)

export default component.exports